import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getStaffToken, setStaffToken } from "../api/http";
import { getStaffProfile, logoutStaff } from "../api/auth";

const StaffAuthContext = createContext(null);

export function StaffAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!getStaffToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const me = await getStaffProfile();
      setUser(me);
    } catch (_) {
      setStaffToken("");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const logout = useCallback(async () => {
    await logoutStaff();
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: !!user,
      isAdmin: user?.role === "admin",
      loading,
      reload,
      logout,
      setUser,
    }),
    [user, loading, reload, logout]
  );

  return <StaffAuthContext.Provider value={value}>{children}</StaffAuthContext.Provider>;
}

export function useStaffAuth() {
  const ctx = useContext(StaffAuthContext);
  if (!ctx) throw new Error("useStaffAuth must be used within StaffAuthProvider");
  return ctx;
}
